import { render, staticRenderFns } from "./ManagerTagging.vue?vue&type=template&id=49feea08&"
import script from "./ManagerTagging.vue?vue&type=script&lang=js&"
export * from "./ManagerTagging.vue?vue&type=script&lang=js&"
import style0 from "./ManagerTagging.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-manager-tagging/src/components/managerTagging/ManagerTagging.vue"
export default component.exports